import { render, staticRenderFns } from "./activeList.vue?vue&type=template&id=317174da&"
import script from "./activeList.vue?vue&type=script&lang=js&"
export * from "./activeList.vue?vue&type=script&lang=js&"
import style0 from "./activeList.vue?vue&type=style&index=0&id=317174da&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports